import { defineMessages } from 'react-intl';

export const ApiDataKeys = Object.freeze({
  EPISODES: 'episodes',
  LABEL: 'label',
} as const);

export const PodcastKeys = Object.freeze({
  ACTIVE_BACKSTAGE_PROGRAM_ID: 'ACTIVE_BACKSTAGE_PROGRAM_ID',
  EPISODES_WITH_LABELS: 'EPISODES_WITH_LABELS',
  NEW_EPISODE_BADGE: 'NEW_EPISODE_BADGE',
  PROGRESS: 'PROGRESS',
  THUMBED_EPISODES: 'THUMBED_EPISODES',
  USER_PROGRAM_DETAILS: 'USER_PROGRAM_DETAILS',
} as const);

export const ActionTypes = Object.freeze({
  ADD_EPISODE_TO_THUMBS_LIST: 'ADD_EPISODE_TO_THUMBS_LIST',
  AESOP_REMOVE_EPISODES_FEEDBACK: 'AESOP_REMOVE_EPISODES_FEEDBACK',
  REMOVE_EPISODE_FROM_THUMBS_LIST: 'REMOVE_EPISODE_FROM_THUMBS_LIST',
  REQUEST_ALL_EPISODES_BY_PROGRAM: 'REQUEST_ALL_EPISODES_BY_PROGRAM',
  REQUEST_ALL_THUMBED_EPISODES: 'REQUEST_ALL_THUMBED_EPISODES',
  REQUEST_ANNOTATE_AESOP_OBJECTS: 'REQUEST_ANNOTATE_AESOP_OBJECTS',
  REQUEST_PODCAST_GET_DETAILS: 'REQUEST_PODCAST_GET_DETAILS',
  SET_ACTIVE_BACKSTAGE_PROGRAM_ID: 'SET_ACTIVE_BACKSTAGE_PROGRAM_ID',
  UPDATE_PODCAST_EPISODE_PROGRESS: 'UPDATE_PODCAST_EPISODE_PROGRESS',
} as const);

export const AllEpisodesSortTypes = Object.freeze({
  NEWEST_TO_OLDEST: 'FORWARD',
  OLDEST_TO_NEWEST: 'REVERSE',
} as const);

export const ComponentEventTypes = Object.freeze({
  [AllEpisodesSortTypes.OLDEST_TO_NEWEST]: 'filter_web_podcast_oldnew',
  [AllEpisodesSortTypes.NEWEST_TO_OLDEST]: 'filter_web_podcast_newold',
} as const);

export const messages = defineMessages({
  seeAllEpisodes: {
    id: 't.seeAllEpisodes',
    defaultMessage: 'See All Episodes',
  },
  moreFromCategory: {
    id: 't.moreFromCategory',
    defaultMessage: 'More from this category',
  },
  viewCategory: {
    id: 't.viewCategory',
    defaultMessage: 'View Category',
  },
  by: {
    id: 't.by',
    defaultMessage: 'By ',
  },
  continueListening: {
    id: 't.continueListening',
    defaultMessage: 'Continue Listening',
  },
  thumbedUpEpisodes: {
    id: 't.thumbedUpEpisodes',
    defaultMessage: 'Thumbed Up Episodes',
  },
  thumbedDownEpisodes: {
    id: 't.thumbedDownEpisodes',
    defaultMessage: 'Thumbed Down Episodes',
  },
  similarEpisodes: {
    id: 't.similarEpisodes',
    defaultMessage: 'Similar Episodes',
  },
  similarPodcasts: {
    id: 't.similarPodcasts',
    defaultMessage: 'Similar Podcasts',
  },
  thumbs: {
    id: 't.thumbs',
    defaultMessage: 'Thumbs',
  },
  seeAll: {
    id: 't.seeAll',
    defaultMessage: 'See All',
  },
  [AllEpisodesSortTypes.NEWEST_TO_OLDEST]: {
    id: 't.newestToOldest',
    defaultMessage: 'Newest to Oldest',
  },
  [AllEpisodesSortTypes.OLDEST_TO_NEWEST]: {
    id: 't.oldestToNewest',
    defaultMessage: 'Oldest to Newest',
  },
  episodesHeader: {
    id: 't.episodesHeader',
    defaultMessage: 'Episodes',
  },
  allEpisodesHeader: {
    id: 't.allEpisodesHeader',
    defaultMessage: 'All Episodes',
  },
  noEpisodes: {
    id: 't.noEpisodes',
    defaultMessage: 'Episodes of this podcast are currently unavailable.',
  },
  browseMorePodcasts: {
    id: 't.browseMorePodcasts',
    defaultMessage: 'Browse More Podcasts',
  },
  description: {
    id: 't.description',
    defaultMessage: 'Description',
  },
  episodeDescription: {
    id: 't.episodeDescription',
    defaultMessage: 'Episode Description',
  },
  thumbedUpEmpty: {
    id: 't.thumbedUpEmpty',
    defaultMessage: 'You have no thumbed up episodes from this podcast.',
  },
  thumbedDownEmpty: {
    id: 't.thumbedDownEmpty',
    defaultMessage: 'You have no thumbed down episodes from this podcast.',
  },
  podcastUnavailable: {
    id: 't.podcastUnavailable',
    defaultMessage: 'Due to our licenses, this podcast is currently unavailable.',
  },
  podcastThumbDownInformation: {
    id: 't.podcastThumbDownInformation',
    defaultMessage: 'Got it. Thumbs help us personalize your podcast recommendations.',
  },
  podcastThumbUpInformation: {
    id: 't.podcastThumbUpInformation',
    defaultMessage:
      'Glad you like this episode! Thumbs help us personalize your podcast recommendations.',
  },
});

// page size for fetching new load of tracks from server
export const PODCAST_EPISODE_LIST_PAGE_SIZE = 20 as const;
export const PODCAST_RECENT_EPISODE_MAX_LIST_SIZE = 10 as const;
